<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle"           
          >
          
          <template v-slot:body>
            <v-layout column overflow-auto>
              <v-row>
							<v-col cols="12" class="pa-0">
								<i-card-top
									class="d-md-flex"
									outlined

                  :useBtnList="[
                      'btnRetrieve', //Retrieve
                      'btnPrint'   //Save Excel
                    ]"
                    @btnRetrieve="btnRetrieve()"                    
                    @btnPrint="btnPrint()"
                    
								>
									<template v-slot:body>
										<v-row no-gutters class="center pa-0 pl-1">
											<v-col cols="12">
												<v-row dense class="ma-0">	
													<v-icon small color="blue" class="pb-0">mdi-circle</v-icon>
													<span class="pa-2 pr-0">Date : </span>													
													<v-col cols="2">
                          <DxDateBox :value="startDate" height="30px"
                                  display-format="yyyy-MM-dd" :acceptCustomValue="false"
                                  @value-changed="e => { reqDtFrom = e.value && getStrFormat(e.value) }" />
                          </v-col>																																
												</v-row>
											</v-col>
										</v-row>
									</template>
								</i-card-top>
							</v-col>
						</v-row>              
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">                
                  <DxDataGrid id="v80a1050" 
                    class="listBox" 
                    :ref="v80a1050Ref"
                    :data-source="gridMainList" :remote-operations="false"
                    :hover-state-enabled="true" :allow-column-resizing="true"
                    :allow-column-reordering="true" :row-alternation-enabled="true"
                    :show-borders="true" :width="grid.width" :show-row-lines="true" key-expr="id"
                    :focused-row-enabled="true" :column-hiding-enabled="false"
                    :selection="{ mode: 'none' }" :sorting="{ mode: 'none' }"                  
                    >
                    
                    <DxColumn data-field="rnum" caption="No" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                     
                    <DxColumn   data-field="divCd" caption="Division" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn   data-field="shipNo" caption="Ship No" width="10%" data-type="string" alignment="center" :allow-editing="false" />

                    <DxColumn   data-field="erectblk" caption="Erection Block" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn   data-field="pntblk" caption="Block" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn   data-field="blstarea" caption="PP Plan Blst Area" width="10%" data-type="number" format="#,###"  alignment="right" :allow-editing="false" />
                    <DxColumn caption= "MID PP" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="stgpsd" caption="P.S.D" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="stgpfd" caption="P.F.D" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    
                    <DxColumn caption= "RESULT" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="stgstrdt	" caption="P.S.D" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="stgfirdt" caption="P.F.D" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    
                    <DxColumn  data-field="diffday" caption= "Delay P.S.D" width="10%" data-type="number" format="#,###"  alignment="right" :allow-editing="false" />
                    <DxColumn  data-field="erectpsd" caption= "Erection Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn  data-field="rmk" caption= "Remark" width="10%" data-type="string" alignment="center" :allow-editing="false" />                    

                    <DxSummary>
                    <DxTotalItem column="shipNo" summary-type="count" display-format="Page Total" />
                    <DxTotalItem column="pntblk" summary-type="count" :customize-text="totalFormat" />
                    <DxTotalItem column="blstarea" summary-type="sum" :customize-text="totalFormat" />
                  </DxSummary>                 	

                  <DxPaging :enabled="true" :page-size="20" />
                  </DxDataGrid>
                </v-col>
              </v-row>
            </v-layout>
          </template> 
        </i-card-vertical>
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn , DxButton , DxExport } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { getDateFormat, getCurrentDate, getFirstDate , getFirstDay, getNumComma} from '@/utils/common.js'
import { v80a1050List } from '@/api/view/hip/A/v80a1050.js'
import { reportView } from '@/api/view/hip/common/common.js'

export default {
  name: 'v80a1050',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxDateBox,
    DxColumn
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      v80a1050Ref: 'v80a1050Ref',
      gridMainList: [],      
      startDate: '',
      stDte: ''
    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.v80a1050Ref)
    },
  },
  methods: {

    getStrFormat(date) {
      this.stDte = getDateFormat(date)
      return getDateFormat(date)
    },

    totalFormat(e) {
      const result = getNumComma(Number(e.value.toFixed(2)), 2)
      return result
    },
    getNumComma(e) {
      const result = getNumComma(e, 2)
      return result
    },
    
    btnRetrieve() {
     
      this.doSearchMain()      
    },

    async doSearchMain() {
      this.openLoading('searching')
      let params = {
        makerCd: this.$store.state.user.makerCd,
        startDate: this.stDte,
      }      
      await v80a1050List(params).then(res => {        
        res.list.forEach(e => {
          this.gridMainList = res.list
        });

      }).finally(() => {
        this.endLoading()
      })

    },

    btnPrint() {

            const param = {
                fileName: 'v80a1050.jrxml',
                as_st_date: this.stDte
            }
            
            console.log(param)
            this.openLoading('searching')
            reportView(param)
                .finally(() => {
                    this.endLoading()
                })
        },
       

   },
   mounted() {    
      this.startDate = getCurrentDate()
      this.gridMainInstance.option('defaultPaging', false)
  }


}

</script>
<style lang="scss" scoped>
  .subTitle {
    font-weight: bold;
    color: black;
  }
  .vat {
    color: blue;
  }
  .receiptBtn {
    font-weight: bold;
  }
  .receiptBtn:hover {
    color: #4980BC;
  }
  .v-btn {
    text-transform: unset !important;
    // height: 16px !important;
  }
</style>